import { default as UpscaleConfirmationModal } from './UpscaleConfirmationModal';
import { default as UpscaleConfirmationModalV2 } from '../UpscaleConfirmationModal.upscale_v2';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';

export default withFeatureBranch({
  upscale_v2: UpscaleConfirmationModalV2,
})(UpscaleConfirmationModal);
